import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const AstronautIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M9 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
			clipRule="evenodd"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M8 1c1.887 0 3.6.747 4.859 1.96A6.98 6.98 0 0 1 15 8a6.97 6.97 0 0 1-1.11 3.783.48.48 0 0 1-.405.217H2.515a.48.48 0 0 1-.406-.217A7 7 0 0 1 8 1m.332 9.147A.43.43 0 0 0 8 10a2 2 0 0 1-1.902-2.619c.062-.191.045-.406-.083-.56l-1.06-1.285c-.138-.169-.372-.214-.59-.213a.962.962 0 1 1 .958-.958c-.001.218.044.452.213.59l1.284 1.06c.155.128.37.145.561.083Q7.675 6 8 6h.011a.59.59 0 0 0 .474-.21l1.62-2.107q.153-.197.35-.342a.41.41 0 0 1 .461-.005A5.5 5.5 0 0 1 13.5 8c0 .793-.167 1.545-.468 2.224a.47.47 0 0 1-.437.276H8.858a.5.5 0 0 1-.387-.183zM2 14.5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1c0 .552-.448.5-1 .5H3c-.552 0-1 .052-1-.5"
			clipRule="evenodd"
		></path>
	</svg>
))
